module.exports = __webpack_public_path__ + "img/12.a5b27df1.jpg";